import { BookingResourceURI } from "@cur8/uri";

export const BookingResource = {
  B2CClinic: new BookingResourceURI("B2C_Clinic"),
};
